import axios from 'axios';
import prepareRequestOptions from '../utils/admin-apis.util';

export const getListData = async (params = '', signal = null) => {
  const options = prepareRequestOptions(
    `/admin/channel-packager/roku/list${params}`,
    'GET',
    null,
    true,
    signal
  );

  const response = await axios(options);
  return response.data;
};

export const createNewData = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/channel-packager/create',
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};
export const assignPackageToChannel = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/channel-packager/channel-assign',
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getLGPackageListData = async (params = '', signal = null) => {
  const options = prepareRequestOptions(
    `/admin/channel-packager/lg/list${params}`,
    'GET',
    null,
    true,
    signal
  );

  const response = await axios(options);
  return response.data;
};

export const createLGNewData = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/channel-packager/lg/create',
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const activeLGPackage = async (payload) => {
  const options = prepareRequestOptions(
    `/admin/channel-packager/lg/toggle`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const viewDataById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/channel-packager/roku/${id}/view`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};
